import {combineReducers} from "redux";
import searchPreviewReducer from "./reducers/searchPreview";
import searchReducer from "./reducers/search";

export const reducer = combineReducers({
  searchPreview: searchPreviewReducer,
  search: searchReducer,
});
